import { Button, Popup, ScrollView } from 'devextreme-react';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { getItemApi } from '../../../apiUtils';
import { Loader } from '../../../components/loader/Loader';
import { useTranslation } from '../../../contexts/translation';
import { Asset } from '../../../types/asset.types';
import { API_URL } from '../../../utils/apiUrl';
import MobileLayout from '../../Tasks/Mobile/components/MobileLayout';
import * as Bar from '../../WorkSheets/Mobile/components/Bar';
import { AssetAttachmentsList } from './AssetAttachmentsList';
import { AssetsMobileEditForm } from './AssetsMobileEditForm';

export interface PageParams {
  assetId: string;
}

export const AssetsMobileEditPage = () => {
  const history = useHistory();
  const { assetId } = useParams<PageParams>();
  const { translate } = useTranslation();
  const transFormName = 'AssetsMobile.Form';

  const [asset, setAsset] = useState<Asset | null>(null);
  const [isLoading, setLoading] = useState(false);
  const [attachmentsPopupVisible, setAttachmentsPopupVisible] = useState(false);

  useEffect(() => {
    getAsset();
  }, []);

  const getAsset = async () => {
    setLoading(true);
    await getItemApi<Asset>({
      url: `${API_URL.ASSET_ITEM}`,
      params: {
        id: assetId,
      },
      callAfterSuccess: (result) => {
        setAsset(result);
      },
    });
    setLoading(false);
  };

  if (isLoading || !asset) return <Loader />;

  return (
    <MobileLayout>
      <Bar.SummaryNavBar
        title={asset.name!}
        onBack={() =>
          history.push({
            pathname: '/mobile',
          })
        }
      />
      <Button
        text={translate!('Attachments', transFormName)}
        stylingMode="outlined"
        width={'100%'}
        onClick={() => setAttachmentsPopupVisible(true)}
      />
      <Popup
        visible={attachmentsPopupVisible}
        onHiding={() => setAttachmentsPopupVisible(false)}
        closeOnOutsideClick={false}
        showCloseButton={true}
        showTitle={true}
        title={translate!('Attachments', transFormName)}
        container=".dx-viewport"
        width={'95%'}
        height={'80%'}
      >
        <ScrollView height={'100%'}>
          <AssetAttachmentsList assetId={Number(assetId)} />
        </ScrollView>
      </Popup>
      <AssetsMobileEditForm
        assetId={Number(assetId)}
        defaultFormData={{
          parentAssetId: asset.parentAssetId,
          name: asset.name!,
          description: asset.description,
          typeId: asset.typeId,
          inventoryNumber: asset.inventoryNumber,
          serialNumber: asset.serialNumber,
          partNumber: asset.partNumber,
          model: asset.model,
          centre: asset.centre,
          producedBySupplierName: asset.producedBySupplierName,
          assetLocationId: asset.assetLocationId,
          building: asset.building,
          room: asset.room,
          statusId: asset.statusId,
        }}
      />
    </MobileLayout>
  );
};
